import common_en_US from './en-US/common.json';
import common_zh_TW from './zh-TW/common.json';
import admin_en_US from './en-US/admin.json';
import admin_zh_TW from './zh-TW/admin.json';
import chatroom_en_US from './en-US/chatroom.json';
import chatroom_zh_TW from './zh-TW/chatroom.json';

const resources = {
    'en-US': {
        common: common_en_US,
        admin: admin_en_US,
        chatroom: chatroom_en_US,
    },
    'zh-TW': {
        common: common_zh_TW,
        admin: admin_zh_TW,
        chatroom: chatroom_zh_TW,
    },
};

export default resources;